<article class="overview-inscriptions-offre-cours">
  <m-panel
    shadow="true"
    :border="true"
  >
    <h4 slot="header">
      {{ $i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.title') }}
    </h4>
    <transition
      name="fade-fast"
      mode="out-in"
    >
      <template v-if="isOverviewInscriptionsOffreCoursLoadingStateActive">
        <div
          class="overview-inscriptions-offre-cours__inscriptions-offre-cours overview-inscriptions-offre-cours__inscriptions-offre-cours--loading"
          key="overview-inscriptions-offre-cours__inscriptions-offre-cours--loading"
        >
          <m-spinner
            title="true"
            description="true"
          />
        </div>
      </template>
      <template v-else-if="inscriptionsOffreCours.length === 0">
        <div
          class="overview-inscriptions-offre-cours__inscriptions-offre-cours overview-inscriptions-offre-cours__inscriptions-offre-cours--error"
          key="overview-inscriptions-offre-cours__inscriptions-offre-cours--error"
        >
          <m-message :state="MMessageState.Error">
            <span v-html="$i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.message.inscriptions_offre_cours_list_empty')" />
          </m-message>
        </div>
      </template>
      <template v-else>
        <div
          class="overview-inscriptions-offre-cours__inscriptions-offre-cours"
          key="overview-inscriptions-offre-cours__inscriptions-offre-cours"
        >
          <template v-for="inscriptionOffreCours in inscriptionsOffreCours">
            <div class="overview-inscriptions-offre-cours__inscriptions-offre-cours overview-inscriptions-offre-cours__inscriptions-offre-cours--data">
              <h6 v-html="$i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.inscription_offre_cours.label', inscriptionOffreCours)" />
              <p>
                <template v-for="inscriptionLieuExamen, index in inscriptionOffreCours.inscriptionsLieuExamen">
                  <p>
                    <template v-if="inscriptionLieuExamen.horodateCampus && inscriptionLieuExamen.horodateHorsCampus">
                      <span v-html="$i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.inscription_lieu_examen.label.multiple_timestamp.type_examen', inscriptionLieuExamen)" />
                      <ul>
                        <li>
                          {{ $i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.inscription_lieu_examen.label.multiple_timestamp.timestamp_campus', inscriptionLieuExamen) }}
                        </li>
                        <li>
                          {{ $i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.inscription_lieu_examen.label.multiple_timestamp.timestamp_hors_campus', inscriptionLieuExamen) }}
                        </li>
                      </ul>
                    </template>
                    <template v-else-if="inscriptionLieuExamen.horodateCampus || inscriptionLieuExamen.horodateHorsCampus">
                      <span v-html="$i18next.t(
                        'modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.inscription_lieu_examen.label.simple_timestamp', 
                        { 
                          ...inscriptionLieuExamen,
                          timestamp: inscriptionLieuExamen.horodateCampus ? inscriptionLieuExamen.horodateCampus : inscriptionLieuExamen.horodateHorsCampus
                        }
                      )" />
                    </template>
                    <template v-else>
                      <span v-html="$i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.inscription_lieu_examen.label.no_timestamp', inscriptionLieuExamen)" />
                    </template>
                  </p>
                </template>
              </p>
            </div>
          </template>
        </div>
      </template>
    </transition>
    <transition
      name="fade-fast"
      mode="out-in"
    >
      <template v-if="isNextStepFormAvailable">
        <div class="overview-inscriptions-offre-cours__selection-inscriptions">
          <h6>
            <strong>
              {{ $i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.selection_inscriptions.label', dossierEtudiant ? dossierEtudiant.session : inscriptionLieuExamenInformations.session) }}
            </strong>
          </h6>
          <m-switch v-model="isInscriptionsLieuExamenTousCampus" />
          <transition
            name="fade-fast"
            mode="out-in"
          >
            <template v-if="isInscriptionsLieuExamenTousCampus">
              <m-button
                :waiting="isTousCampusButtonLoadingStateActive"
                @click="onTousCampusButtonClick"
              >
                {{ $i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.selection_inscriptions.button.tous_campus') }}
              </m-button>
            </template>
            <template v-else>
              <m-button @click="onNextStepButtonClick">
                {{ $i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.selection_inscriptions.button.next_step') }}
              </m-button>
            </template>
          </transition>
        </div>
      </template>
    </transition>
  </m-panel>
  <m-modal
    id="overview-inscriptions-offre-cours__informations-dialog"
    :size="MModalSize.Large"
  >
    <template #header>
      <h4>
        {{ $i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.modal.informations_generale.title') }}
      </h4>
    </template>
    <p v-html="$i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.modal.informations_generale.situation.title')" />
    <ul>
      <li v-html="$i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.modal.informations_generale.situation.options.situation_a.message')" />
      <li v-html="$i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.modal.informations_generale.situation.options.situation_b.message')" />
      <li>
        <span v-html="$i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.modal.informations_generale.situation.options.situation_c.message')" />
        <ul>
          <li v-html="$i18next.t('modules.inscription-lieu-examen.overview.OverviewInscriptionOffreCours.modal.informations_generale.situation.options.situation_c.note')" />
        </ul>
      </li>
    </ul>
  </m-modal>
</article>